import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORKS]: {
		url: '/company/:companyId/reports/done_works/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK]: {
		url: '/company/:companyId/reports/done_works/:doneWorksId/',
	},
  [ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK_PREVIEW]: {
		url: '/company/:companyId/reports/done_works/:doneWorksId/preview/',
	},
}